import { MobileWIPCSS } from './MobileWIPCSS.styled'

export const MobileWIP = () => {
  return (
    <MobileWIPCSS>
      <div id='mobile_temp_page_wrapper'>
        <div className='yolorekt_logo-stacked'></div>
        <div className='pardon_our_dust'>
          <p>Our mobile app is currently being enhanced for optimal next-degen experiences.</p>
          <p className='second'>
            In the meantime please enjoy YOLOBOT – the first-ever Telegram bot where you can place leveraged bids at
            1000x.
          </p>
        </div>
        <div className='yolobot_feature'>
          <div className='yolobot_logo'></div>
          <a id='bot-button' href='https://t.me/yolorektbot' type='button' target='blank' rel='noopener noreferrer'>
            Bid now on <strong>Telegram</strong>
          </a>
          <div className='view_docs'>
            <a href='https://docs.yolorekt.finance/docs/yolobot/quick-start-and-tutorial-guide' target='blank'>
              YOLOBOT quick-start and tutorial guide
            </a>
          </div>
        </div>

        <footer>
          <div id='landing-details'>
            <div id='priv-terms'>
              <a href='https://docs.yolorekt.finance/docs/legal/privacy-policy' target='blank'>
                Privacy Policy
              </a>
              &nbsp;&nbsp;•&nbsp;&nbsp;
              <a href='https://docs.yolorekt.finance/docs/legal/terms-of-service' target='blank'>
                Terms of Service
              </a>
              &nbsp;&nbsp;•&nbsp;&nbsp;
              <a href='https://docs.yolorekt.finance' target='blank'>
                Docs
              </a>
            </div>

            <div id='copyright'>
              <strong>
                © Copyright
                <script type='text/javascript'>var year = new Date();document.write(year.getFullYear());</script>2023
              </strong>
              All rights reserved
            </div>
          </div>

          <div id='landing-social'>
            <a
              href='https://twitter.com/playyolorekt'
              target='blank'
              rel='noopener noreferrer'
              className='icon twitter'
            >
              {''}
            </a>
            <a href='https://vm.tiktok.com/ZTdmEw6xk/' target='blank' rel='noopener noreferrer' className='icon tiktok'>
              {''}
            </a>
            <a href='https://medium.com/yolorekt' target='blank' rel='noopener noreferrer' className='icon medium'>
              {''}
            </a>
            <a
              href='https://t.me/joinchat/NBBv1hQmV26flFM_5MD4_w'
              target='blank'
              rel='noopener noreferrer'
              className='icon telegram'
            >
              {''}
            </a>
            <a href='https://discord.gg/yolorekt' target='blank' rel='noopener noreferrer' className='icon discord'>
              {''}
            </a>
            <a
              href='mailto:support@yolorekt.com?Subject=Hello%20again'
              target='blank'
              rel='noopener noreferrer'
              className='icon email'
            >
              {''}
            </a>
          </div>
        </footer>
      </div>
    </MobileWIPCSS>
  )
}
